import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../Config'; // o '../Config' si el path cambia
import {
  LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Legend,
  BarChart, Bar, ResponsiveContainer, PieChart, Pie, Cell
} from 'recharts';

const colores = ['#8884d8', '#82ca9d', '#ffc658'];

export default function EsquemasAdmin() {
  const [ventasPorMetodo, setVentasPorMetodo] = useState([]);
  const [productosMasVendidos, setProductosMasVendidos] = useState([]);
  const [ventasComprasData, setVentasComprasData] = useState([]);
  const [propinasMensuales, setPropinasMensuales] = useState([]);
  const [ventasUltimosDias, setVentasUltimosDias] = useState([]);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/ventas`)
      .then(res => {
        const ventas = res.data;

        const metodoData = {};
        const productoData = {};

        ventas.forEach(v => {
          metodoData[v.metodoPago] = (metodoData[v.metodoPago] || 0) + 1;

          const nombres = v.nombre?.split(' | ') || [];
          const cantidades = v.cantidad?.split('-').map(Number) || [];

          nombres.forEach((nombre, idx) => {
            productoData[nombre] = (productoData[nombre] || 0) + (cantidades[idx] || 0);
          });
        });

        setVentasPorMetodo(Object.entries(metodoData).map(([metodo, cantidad]) => ({ metodo, cantidad })));
        setProductosMasVendidos(Object.entries(productoData).map(([nombre, cantidad]) => ({ nombre, cantidad })));
      });

      // 🔽 AGREGAR ESTOS DATOS SIMULADOS AL FINAL:
  setVentasComprasData([
    { mes: 'Enero', ventas: 3000, compras: 2000 },
    { mes: 'Febrero', ventas: 4000, compras: 2500 },
    { mes: 'Marzo', ventas: 3500, compras: 3000 }
  ]);

  setPropinasMensuales([
    { mes: 'Enero', monto: 200 },
    { mes: 'Febrero', monto: 250 },
    { mes: 'Marzo', monto: 300 }
  ]);

  setVentasUltimosDias([
    { dia: 'Lunes', total: 500 },
    { dia: 'Martes', total: 700 },
    { dia: 'Miércoles', total: 600 },
    { dia: 'Jueves', total: 800 },
    { dia: 'Viernes', total: 1000 },
    { dia: 'Sábado', total: 1200 },
    { dia: 'Domingo', total: 900 }
  ]);


    {/*axios.get('http://localhost:8080/api/esquemas/ventas-vs-compras')
      .then(res => setVentasComprasData(res.data))
      .catch(err => console.error('Error ventas-vs-compras:', err));

    axios.get('http://localhost:8080/api/esquemas/propinas-por-mes')
      .then(res => setPropinasMensuales(res.data))
      .catch(err => console.error('Error propinas-por-mes:', err));

    axios.get('http://localhost:8080/api/esquemas/ventas-por-dia')
      .then(res => setVentasUltimosDias(res.data))
      .catch(err => console.error('Error ventas-por-dia:', err));*/}
  }, []);

  return (
    <div className="p-6 space-y-12">
      <h1 className="text-3xl font-bold text-center mb-8">📈 Esquemas de Datos</h1>

      {/* 1. Ventas por Método de Pago */}
      <div>
        <h2 className="text-xl font-semibold mb-4 text-center">Ventas por Método de Pago</h2>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={ventasPorMetodo}
              dataKey="cantidad"
              nameKey="metodo"
              cx="50%"
              cy="50%"
              outerRadius={100}
              label
            >
              {ventasPorMetodo.map((_, idx) => (
                <Cell key={`cell-${idx}`} fill={colores[idx % colores.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* 2. Productos Más Vendidos */}
      <div>
        <h2 className="text-xl font-semibold mb-4 text-center">Productos Más Vendidos</h2>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={productosMasVendidos}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="nombre" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="cantidad" fill="#82ca9d" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* 3. Ventas vs Compras mensual */}
      <div>
        <h2 className="text-xl font-semibold mb-4 text-center">Ventas vs Compras (mensual)</h2>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={ventasComprasData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="mes" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="ventas" stroke="#8884d8" name="Ventas" />
            <Line type="monotone" dataKey="compras" stroke="#82ca9d" name="Compras" />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* 4. Propinas por mes */}
      <div>
        <h2 className="text-xl font-semibold mb-4 text-center">Propinas por mes</h2>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={propinasMensuales}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="mes" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="monto" fill="#ffc658" name="Propinas" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* 5. Totales de venta por día */}
      <div>
        <h2 className="text-xl font-semibold mb-4 text-center">Totales de venta por día (últimos 7 días)</h2>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={ventasUltimosDias}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="dia" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="total" fill="#8884d8" name="Total Vendido" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
